import { ChevronRight } from "lucide-react";
import { ROLE_TABS, accentFor } from "@/lib/roles";

export const RolePicker = ({ onPick }) => (
  <div className="grid gap-3" data-testid="role-picker">
    {ROLE_TABS.map((tab, i) => {
      const accent = accentFor(tab.key);
      const Icon = tab.icon;
      const isTour = tab.key === "tour";
      return (
        <button
          key={tab.key}
          type="button"
          data-testid={`role-picker-${tab.key}`}
          onClick={() => onPick(tab.key)}
          className={`alr-rise group flex min-h-[76px] items-center gap-4 rounded-2xl border bg-white/[0.04] p-4 text-left backdrop-blur-md transition-[transform,background-color,border-color] duration-200 hover:-translate-y-0.5 hover:bg-white/[0.08] ${isTour ? "alr-pulse" : ""}`}
          style={{ borderColor: `${accent}${isTour ? "AA" : "55"}`, animationDelay: `${i * 60}ms`, "--pulse": accent }}
        >
          <span
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border"
            style={{ background: `${accent}1A`, borderColor: `${accent}66`, color: accent }}
          >
            <Icon size={24} strokeWidth={1.75} />
          </span>
          <span className="flex-1">
            <span className="mb-0.5 block text-[15px] font-extrabold tracking-[0.6px]" style={{ color: accent }}>{tab.label}</span>
            <span className="block text-xs leading-4 text-[#A0A0A0]">{tab.subtitle}</span>
          </span>
          <ChevronRight size={20} className="text-neutral-500 transition-transform duration-200 group-hover:translate-x-1" />
        </button>
      );
    })}
  </div>
);

export const RoleTabs = ({ active, onPick, keys }) => (
  <div className={keys ? "grid grid-cols-2 gap-2 sm:grid-cols-4" : "flex gap-2 overflow-x-auto pb-1"} data-testid="role-tabs">
    {ROLE_TABS.filter((t) => !keys || keys.includes(t.key)).map((tab) => {
      const accent = accentFor(tab.key);
      const on = tab.key === active;
      const Icon = tab.icon;
      return (
        <button
          key={tab.key}
          type="button"
          data-testid={`role-tab-${tab.key}`}
          onClick={() => onPick(tab.key)}
          className={`flex ${keys ? "" : "min-w-[84px] flex-1"} flex-col items-center gap-1 rounded-lg border px-2 py-3 transition-colors duration-200`}
          style={{
            borderColor: on ? accent : "#333",
            background: on ? "rgba(255,255,255,0.05)" : "rgba(26,26,26,0.85)",
            color: on ? accent : "#A0A0A0",
          }}
        >
          <Icon size={18} />
          <span className="text-center text-[10px] font-extrabold uppercase leading-tight tracking-[1.3px]">{tab.label}</span>
        </button>
      );
    })}
  </div>
);
